$(document).ready(function (){

	const newsSlider = new window.Swiper('.news-slider', {
		slidesPerView: 1,
		autoplay: false,
		cssWidthAndHeight: true,
		spaceBetween: 20,
		a11y: {
			prevSlideMessage: 'Vorheriges Element',
			nextSlideMessage: 'Nächstes Element',
		},
		breakpoints: {
			576: {
			slidesPerView: 2,
			spaceBetween: 30,
			},
			1200: {
			slidesPerView: 3,
			spaceBetween: 30,
			},
		},
		// loop: true,
		pagination: {
			el: '.news-slider .swiper-pagination',
			dynamicBullets: true,
			dynamicMainBullets: 3,
			clickable: true
		},
		navigation: {
			nextEl: '.news-slider .swiper-news-next',
			prevEl: '.news-slider .swiper-news-prev',
		},
		keyboard: {
			enabled: true,
			pageUpDown: false
		}
    });

	newsSlider.on('slideChangeTransitionEnd', function(){
		if (newsSlider.slides[newsSlider.realIndex].querySelector('a')) {
			newsSlider.slides[newsSlider.realIndex].querySelector('a').focus()
		}
	})
});
